// @ts-ignore
import { bootstrapApplication } from '@angular/platform-browser';
// @ts-ignore
import { provideHttpClient, withInterceptors } from '@angular/common/http';
// @ts-ignore
import { provideRouter } from '@angular/router';
// @ts-ignore
import { LOCALE_ID } from '@angular/core';
// @ts-ignore
import { registerLocaleData } from '@angular/common';
// @ts-ignore
import localePtBr from '@angular/common/locales/pt';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { authExpiredInterceptor } from './app/interceptors/auth-expired.interceptor';

registerLocaleData(localePtBr, 'pt-BR');

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withInterceptors([authExpiredInterceptor])),
    provideRouter(routes),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
  ]
}).catch((error: any) => console.error(error));
